import React, { PureComponent } from 'react';
import { Popconfirm } from 'antd';
import TableC from '../../../basicElement/TableC';
import format from '../../../shared/format';
import renderEnhancer from '../../../shared/renderEnhancer';
import cellRenderEnhancer, { beforeChangeEnhancer } from '../../../shared/cellRenderEnhancer';

export default class List extends PureComponent {
    getColumns = () => {
        const { update, remove, showAttac ,showUpdate } = this.props;
        const columns = [{
            title: '国家核查编号',
            dataIndex: 'nationVerifyNumber',
            key: 'nationVerifyNumber',
            width: 100,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {investigationName } = record;
                            if( (investigationName || '').length > 30 ){
                                return (
                                    <div style={{ width:400, wordWrap:'break-word' }}>{investigationName}</div>
                                );
                            }
                        }
                })(text => text?text.substring(0,30):'')
            ),
        }, {
            title: '项目名称',
            dataIndex: 'investigationSpecialName',
            key: 'investigationSpecialName',
            width: 200,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {investigationSpecialName } = record;
                            if( (investigationSpecialName|| '').length > 25 ){
                                return (
                                    <div style={{ width:400, wordWrap:'break-word' }}>{investigationSpecialName}</div>
                                );
                            }
                        }
                })(text => text?text.substring(0,25):'')
            ),
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 100,
        }, {
            title: '核查机构',
            dataIndex: 'agencyName',
            key: 'agencyName',
            width: 100,
            render: (text, record) => {
                const { verifyAgencyRemark } = record;
                return `${text}${verifyAgencyRemark?`(${verifyAgencyRemark})`:''}`;
            }
        }, {
            title: '被核查研究中心',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 130,
        }, {
            title: '科室',
            dataIndex: 'departmentName',
            key: 'departmentName',
            width: 100,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 100,
        }, {
            title: '城市',
            dataIndex: 'city',
            key: 'city',
            width: 100,
        }, {
            title: '实际入组例数',
            dataIndex: 'siteRandomAmount',
            key: 'siteRandomAmount',
            width: 100,
        }, {
            title: '计划核查时间',
            dataIndex: 'planVerifyDateEnd',
            key: 'planVerifyDateEnd',
            sorter: true,
            width: 120,
            render: (text , row) => {
                const { planVerifyDateBegin ,planVerifyDateEnd} = row;
                return format('date', planVerifyDateBegin)+'~'+format('date', planVerifyDateEnd)
            },
        }, {
            title: '实际核查时间',
            dataIndex: 'actualVerifyDateEnd',
            key: 'actualVerifyDateEnd',
            sorter: true,
            width: 120,
            render: (text , row) => {
                const { actualVerifyDateBegin ,actualVerifyDateEnd} = row;
                return format('date', actualVerifyDateBegin)+'~'+format('date', actualVerifyDateEnd)
            },
        }, {
            title: '核查结果',
            dataIndex: 'verifyResult',
            key: 'verifyResult',
            width: 100,
        }, {
            title: '主要核查问题',
            dataIndex: 'verifyContent',
            key: 'verifyContent',
            width: 100,
            render: renderEnhancer(
                cellRenderEnhancer({
                    renderContent: record => {
                        const {verifyContent } = record;
                            if( (verifyContent|| '').length > 10 ){
                                return (
                                    <div style={{ width:400, wordWrap:'break-word' }}>{verifyContent}</div>
                                );
                            }
                        }
                })(text => text?text.substring(0,25):'')
            ),
        }, {
            title: '业务线',
            dataIndex: 'lineName',
            key: 'lineName',
            width: 100,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 140,
        }, {
            title: '项目经理 ',
            dataIndex: 'mainPmName',
            key: 'mainPmName',
            width: 100,
        }, {
            title: 'PML',
            dataIndex: 'pmlName',
            key: 'pmlName',
            width: 100,
        }, {
            title: '领域leader',
            dataIndex: 'invAreaLeaderNameCode',
            key: 'invAreaLeaderNameCode',
            width: 100,
        }, {
            title: '项目类型',
            dataIndex: 'investigationGlobalTypeShow',
            key: 'investigationGlobalTypeShow',
            width: 100,
        }, {
            title: '项目级别',
            dataIndex: 'levelName',
            key: 'levelName',
            width: 100,
        }, {
            title: '项目阶段',
            dataIndex: 'investigationStageNames',
            key: 'investigationStageNames',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'investigationTypeName',
            key: 'investigationTypeName',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 100,
        }, {
            title: '疾病分类',
            dataIndex: 'diseaseClassName',
            key: 'diseaseClassName',
            width: 100,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 100,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeShow',
            key: 'investigationMedicineTypeShow',
            width: 100,
        }, {
            title: '治疗方式',
            dataIndex: 'treatmentMethodName',
            key: 'treatmentMethodName',
            width: 100,
        }, {
            title: '药物（疗法）分类/主要作用靶点',
            dataIndex: 'drugMainTargets',
            key: 'drugMainTargets',
            width: 100,
        }, {
            title: '研究药物通用名称/产品具体名称/技术名称',
            dataIndex: 'investigationMedicine',
            key: 'investigationMedicine',
            width: 100,
        }, {
            title: '给药方式',
            dataIndex: 'administrationModeName',
            key: 'administrationModeName',
            width: 100,
        }, {
            title: '项目分期',
            dataIndex: 'byStageNames',
            key: 'byStageNames',
            width: 100,
        }, {
            title: '受试者类型',
            dataIndex: 'testeeTypeName',
            key: 'testeeTypeName',
            width: 100,
        },{
            title: '申办方',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
            width: 100,
        },{
            title: 'CRO',
            dataIndex: 'croName',
            key: 'croName',
            width: 100,
        },{
            title: '项目计划开始时间',
            dataIndex: 'investigationPlanBeginTime',
            key: 'investigationPlanBeginTime',
            width: 100,
            render: text => format('date', text),
        },{
            title: '项目计划结束时间',
            dataIndex: 'investigationPlanEndTime',
            key: 'investigationPlanEndTime',
            width: 100,
            render: text => format('date', text),
        },{
            title: '合同额含税/人民币（元）',
            dataIndex: 'jdeContractAmount',
            key: 'jdeContractAmount',
            width: 100,
        },{
            title: '津石实际负责中心数量',
            dataIndex: 'siteNum',
            key: 'siteNum',
            width: 100,
        },{
            title: '津石实际随机（入组）数量',
            dataIndex: 'randomAmount',
            key: 'randomAmount',
            width: 100,
        },{
            title: '是否为对垒项目',
            dataIndex: 'isAgainstInvestigationShow',
            key: 'isAgainstInvestigationShow',
            width: 100,
        },{
            title: '对垒公司名称',
            dataIndex: 'competingCompanyNames',
            key: 'competingCompanyNames',
            width: 100,
        },{
            title: '录入者',
            dataIndex: 'createUserNameCode',
            key: 'createUserNameCode',
            width: 100,
        },{
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            fixed: 'right',
            width: 140,
            render: (text, record) => {
                const { canEdit, canDelete, nationVerifyId ,nationVerifyNumber,nationVerifySiteId} = record;
                return (
                    <span>
                        {
                            canEdit &&
                            <span>
                                <a onClick={() => showUpdate('edit', record)}>修改</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {
                            canDelete &&
                            <span>
                                <Popconfirm title="确定删除该记录?" onConfirm={() => remove(nationVerifyId)}>
                                    <a>删除</a>
                                </Popconfirm>
                                <span className="ant-divider" />
                            </span>
                        }
                        <span onClick={()=>showAttac({nationVerifySiteId,nationVerifyNumber})}><a>查看附件</a></span>
                    </span>
                );
            }
        }];
        return columns;
    };

    render() {
        const { loading, data, pagination, onChange,sortParams } = this.props;
        const scrollY = (document.body || document.documentElement).clientHeight - 250;
        return (
            <TableC
                loading={loading}
                columns={this.getColumns()}
                data={data}
                scrollY={scrollY}
                sortParams={sortParams}
                pagination={pagination}
                onChange={onChange}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/qualityManagement/Nationalverification/components/List.js